document.querySelectorAll('.facets__disclosure > summary').forEach(function (summary) {
  summary.addEventListener('click', function (event) {
    event.preventDefault();

    var thisDetails = summary.closest('.facets__disclosure');
    var wasOpen = thisDetails.hasAttribute('open');

    document.querySelectorAll('.facets__disclosure[open]').forEach(function (other) {
      other.removeAttribute('open');
    });

    if (!wasOpen) {
      thisDetails.setAttribute('open', '');
    }
  });
});

document.addEventListener('click', function (event) {
  document.querySelectorAll('.facets__disclosure[open]').forEach(function (details) {
    if (!details.contains(event.target)) {
      details.removeAttribute('open');
    }
  });
});

function initPriceSlider(slider) {
  if (slider.dataset.priceSliderInit) return;
  slider.dataset.priceSliderInit = 'true';

  var minRange = slider.querySelector('[data-price-slider-min]');
  var maxRange = slider.querySelector('[data-price-slider-max]');
  var fill = slider.querySelector('[data-price-slider-fill]');
  var valuesLabel = slider.querySelector('[data-price-slider-values]');
  var currency = slider.getAttribute('data-currency') || '';
  var container = slider.parentElement.querySelector('price-range');
  if (!container) return;
  var minField = container.querySelector('[data-price-field="min"]');
  var maxField = container.querySelector('[data-price-field="max"]');
  var rangeMax = Number(minRange.max) || 100;
  var trackWrap = slider.querySelector('.price-slider__track-wrap');

  function formatMoney(value) {
    return currency + Number(value).toLocaleString();
  }

  function updateDisplay() {
    var minPct = (Number(minRange.value) / rangeMax) * 100;
    var maxPct = (Number(maxRange.value) / rangeMax) * 100;
    fill.style.left = minPct + '%';
    fill.style.right = (100 - maxPct) + '%';
    if (valuesLabel) {
      valuesLabel.textContent = formatMoney(minRange.value) + ' — ' + formatMoney(maxRange.value);
    }
  }

  function onSliderInput(changed) {
    var minVal = Number(minRange.value);
    var maxVal = Number(maxRange.value);
    var gap = 1;
    if (changed === 'min' && minVal > maxVal - gap) minRange.value = maxVal - gap;
    if (changed === 'max' && maxVal < minVal + gap) maxRange.value = minVal + gap;
    updateDisplay();
    if (minField) minField.value = minRange.value;
    if (maxField) maxField.value = maxRange.value;
  }

  minRange.addEventListener('input', function (e) { e.stopPropagation(); onSliderInput('min'); });
  maxRange.addEventListener('input', function (e) { e.stopPropagation(); onSliderInput('max'); });
  minRange.addEventListener('change', function () {
    if (minField) {
      minField.dispatchEvent(new Event('input', { bubbles: true }));
      minField.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  maxRange.addEventListener('change', function () {
    if (maxField) {
      maxField.dispatchEvent(new Event('input', { bubbles: true }));
      maxField.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  if (trackWrap) {
    trackWrap.addEventListener('click', function (e) {
      // A real thumb drag/click already fired its own input/change above — ignore it here.
      if (e.target.classList && e.target.classList.contains('price-slider__range')) {
        return;
      }

      var rect = trackWrap.getBoundingClientRect();
      var pct = (e.clientX - rect.left) / rect.width;
      pct = Math.max(0, Math.min(1, pct));
      var clickValue = pct * rangeMax;

      var minVal = Number(minRange.value);
      var maxVal = Number(maxRange.value);
      var distToMin = Math.abs(clickValue - minVal);
      var distToMax = Math.abs(clickValue - maxVal);

      if (distToMin <= distToMax) {
        minRange.value = Math.min(clickValue, maxVal - 1).toFixed(2);
        onSliderInput('min');
        minRange.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        maxRange.value = Math.max(clickValue, minVal + 1).toFixed(2);
        onSliderInput('max');
        maxRange.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updateDisplay();
}

document.querySelectorAll('[data-price-slider]').forEach(initPriceSlider);

var priceSliderObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;
      if (node.matches && node.matches('[data-price-slider]')) {
        initPriceSlider(node);
      }
      if (node.querySelectorAll) {
        node.querySelectorAll('[data-price-slider]').forEach(initPriceSlider);
      }
    });
  });
});
priceSliderObserver.observe(document.body, { childList: true, subtree: true });